import React from 'react'
import { useProductsContext } from '../context/products_context'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import Error from './Error'
import Loading from './Loading'
import Product from './Product'

const FeaturedProducts = () => {
  let {featured_products:featured, products_loading:loading, products_error:error} = useProductsContext();
if (loading){
 return <Loading></Loading>
}

if (error){
  return <Error></Error>
}
  return (<Wrapper className='section'>
             <div className='title'>
                   <h2>New Arrivals</h2>
                   <div className='underline'></div>
             </div>
             <section className='section-center featured'>
                  {featured.slice(0,6).reverse().map((product)=>{
                    return <Product key={product.id} {...product}></Product>
                  })

                  }

             </section>
         <Link to='products' className='btn'>All Products</Link>



  </Wrapper>
  
  
    )

    
}

const Wrapper = styled.section`
.underline{ background:rgb(237, 182, 72)};
  background: white;

  h2{
    font-family: 'Simonetta', cursive;
  }
  .featured {
    margin: 4rem auto;
    display: grid;
    gap: 2.5rem;
    img {
      height: 225px;
      width:100%;
    }
  }
  .btn {
    display: block;
    width: 148px;
    margin: 0 auto;
    text-align: center;
    background-color:rgb(237, 182, 72);
    transition:0.5s;
  }

  .btn:hover{
    background-color:rgb(237, 72, 152);
    color:white;
  }
  @media (min-width: 576px) {
    .featured {
      grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
    }
  }
`

export default FeaturedProducts
